export default "<layer id=\"{{layer_id}}_{{unique_signature}}\"/>";